import React from 'react';
import ReactDOM from 'react-dom';
import * as serviceWorker from './serviceWorker';
import {RootStoreProvider} from "./stores/rootStore";
import 'mobx-react-lite/batchingForReactDom'
import {Root} from "./components";
import "./styles/index.scss";

require('bootstrap');
require('bootstrap/js/src/index');

const root = document.getElementById('wem-chart-root')
if (root) {
  ReactDOM.render(
    <React.StrictMode>
      <RootStoreProvider>
        <Root/>
      </RootStoreProvider>
    </React.StrictMode>,
    root,
  );
}

// If you want your app to work offline and load faster, you can change
// unregister() to register() below. Note this comes with some pitfalls.
// Learn more about service workers: https://bit.ly/CRA-PWA
serviceWorker.unregister();
